import React from 'react';
import { Link } from 'react-router-dom';
import './ServiceHero.css';

const ServiceHero = ({
  serviceName,
  heading,
  description,
  points = [],
  buttonText = "Discuss Your Project",
  buttonLink = "#enquiry-form-section",
  illustrationUrl = null,
}) => {
  if (!heading && !description) return null;

  const handleScroll = (e) => {
    if (buttonLink && buttonLink.startsWith("#")) {
      e.preventDefault();
      const targetId = buttonLink.replace("#", "");
      const targetElement = document.getElementById(targetId);
      if (targetElement) {
        targetElement.scrollIntoView({ behavior: "smooth" });
      }
    }
  };

  return (
    <section className="service-hero-section">
      <div className="service-hero-section__glow-spot service-hero-section__glow-spot--1"></div>
      <div className="service-hero-section__glow-spot service-hero-section__glow-spot--2"></div>

      <div className="service-hero-section__container">
        
        {/* Left Content Side */}
        <div className="service-hero-section__content">
          
          {/* Breadcrumbs */}
          <nav className="service-hero-section__breadcrumbs" aria-label="Breadcrumb">
            <Link to="/" className="service-hero-section__breadcrumb-link">Home</Link>
            <span className="service-hero-section__breadcrumb-arrow">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="9 18 15 12 9 6"></polyline>
              </svg>
            </span>
            
            <Link to="/services" className="service-hero-section__breadcrumb-link">Services</Link>
            <span className="service-hero-section__breadcrumb-arrow">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="9 18 15 12 9 6"></polyline>
              </svg>
            </span>

            <span className="service-hero-section__breadcrumb-current">{serviceName}</span>
          </nav>

          {/* Service Tag */}
          {serviceName && (
            <div className="service-hero-section__tag">
              <span className="service-hero-section__tag-dot"></span>
              <span>{serviceName}</span>
            </div>
          )}

          {/* Main Heading */}
          {heading && (
            <h1 className="service-hero-section__title">{heading}</h1>
          )}

          {/* Description */}
          {description && (
            <p className="service-hero-section__description">{description}</p>
          )}

          {/* 4 Checkmark Points */}
          {points && points.length > 0 && (
            <ul className="service-hero-section__points-list">
              {points.slice(0, 4).map((point, index) => (
                <li key={index} className="service-hero-section__point-item">
                  <span className="service-hero-section__check-icon">
                    <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                      <polyline points="20 6 9 17 4 12" />
                    </svg>
                  </span>
                  <span className="service-hero-section__point-text">{point}</span>
                </li>
              ))}
            </ul>
          )}

          {/* Action CTA Button */}
          {buttonText && (
            <div className="service-hero-section__actions">
              {buttonLink.startsWith("#") ? (
                <a href={buttonLink} onClick={handleScroll} className="service-hero-section__cta-button">
                  <span>{buttonText}</span>
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <line x1="5" y1="12" x2="19" y2="12"></line>
                    <polyline points="12 5 19 12 12 19"></polyline>
                  </svg>
                </a>
              ) : (
                <Link to={buttonLink} className="service-hero-section__cta-button">
                  <span>{buttonText}</span>
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                    <line x1="5" y1="12" x2="19" y2="12"></line>
                    <polyline points="12 5 19 12 12 19"></polyline>
                  </svg>
                </Link>
              )}
            </div>
          )}

        </div>

        {/* Right Illustration Side */}
        <div className="service-hero-section__visual">
          <div className="service-hero-section__illustration-wrapper">
            {illustrationUrl && (
              <img 
                src={illustrationUrl} 
                alt={serviceName || "Service Illustration"} 
                className="service-hero-section__image" 
              />
            )}
          </div>
        </div>

      </div>
    </section>
  );
};

export default ServiceHero;